export enum OrganizationDialogTab {
    Info = 0,
    Identifiers = 1,
    Contacts = 2
}
